import { withDependencies, named } from '@wix/thunderbolt-ioc'
import type { IStructureAPI, IPropsStore } from '@wix/thunderbolt-symbols'
import { PageFeatureConfigSymbol, StructureAPI, Props } from '@wix/thunderbolt-symbols'
import type { ComponentWillMount, ViewerComponent } from 'feature-components'
import type { ChatPageConfig } from './types'
import { name } from './symbols'

export const Chat = withDependencies(
	[named(PageFeatureConfigSymbol, name), StructureAPI, Props],
	(
		pageFeatureConfig: ChatPageConfig,
		structureAPI: IStructureAPI,
		propsStore: IPropsStore
	): ComponentWillMount<ViewerComponent> => {
		return {
			componentTypes: ['TPAGluedWidget', 'tpaWidgetNative'],
			componentWillMount(widget) {
				const chatWidgetData = pageFeatureConfig.chatWidgetsOnPage[widget.id]
				if (chatWidgetData) {
					const { childrenToUpdate, root, parentOfRoot, compTemplateId } = chatWidgetData

					const propsToUpdate = childrenToUpdate.reduce(
						(previousProps, id) => ({
							...previousProps,
							[id]: {
								key: compTemplateId,
							},
						}),
						{}
					)

					structureAPI.removeComponentFromParent(parentOfRoot, root)
					structureAPI.addComponentToParent('masterPage', root)
					propsStore.update(propsToUpdate)
				}
			},
		}
	}
)
